<template>
  <div class="info-group-append">
    <svg
      :id="`tooltip-${id}`"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-info-circle"
      v-bind:class="variant || 'info'"
      viewBox="0 0 16 16"
    >
      <path
        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
      />
      <path
        d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
      />
    </svg>
    <b-tooltip :target="`tooltip-${id}`" :variant="variant || 'info'">
      {{ desc }}
    </b-tooltip>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: null,
    };
  },
  name: "Tooltip",
  props: {
    desc: String,
    variant: String,
  },
  mounted() {
    this.id = this._uid;
  },
};
</script>
<style scoped>
.bi-info-circle {
  width: 3ch;
  height: 3ch;
}

.bi-info-circle:hover,
.bi-info-circle:focus,
.bi-info-circle:active {
  width: 3ch;
  height: 3ch;
  border: 0;
}

.info {
  color: #17a2b8;
  border-color: transparent;
}

.danger {
  color: #dc3545;
}

.warning {
  color: #ffc107;
}

.info-group-append {
  width: 4ch;
  height: 4ch;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
